import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import Parser from "html-react-parser";
import { Wrapper, Text, CloseBtn } from "./styles/flash-message-styles";

const FlashMessage = ({
  showFlashMessage,
  message,
  backgroundColour,
  flashMessageIcon,
  success,
  showFlashMessageCloseButton,
  closeAction,
}) => (
  <Wrapper
    flashMessageIcon={flashMessageIcon}
    showFlashMessage={showFlashMessage}
    backgroundColour={backgroundColour}
  >
    {flashMessageIcon && <FontAwesomeIcon icon={flashMessageIcon} />}
    {success && <FontAwesomeIcon icon={faCheck} />}
    <Text flashMessageIcon={flashMessageIcon}>{Parser(message)}</Text>
    {showFlashMessageCloseButton && (
      <CloseBtn onClick={() => closeAction()}>
        <FontAwesomeIcon icon={faTimes} />
      </CloseBtn>
    )}
  </Wrapper>
);

FlashMessage.propTypes = {
  backgroundColour: PropTypes.string,
  showFlashMessage: PropTypes.bool.isRequired,
  flashMessageIcon: PropTypes.string,
  message: PropTypes.string.isRequired,
  success: PropTypes.bool,
  showFlashMessageCloseButton: PropTypes.bool,
  closeAction: PropTypes.func,
};

FlashMessage.defaultProps = {
  backgroundColour: PropTypes.isNull,
  flashMessageIcon: PropTypes.isNull,
  success: PropTypes.isNull,
  showFlashMessageCloseButton: PropTypes.isNull,
  closeAction: PropTypes.isNull,
};

export default FlashMessage;
